module.exports = __webpack_public_path__ + "img/mov.e4de76ac.png";